import {
    Aurelia,
    PLATFORM,
} from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';
import 'polyfill-array-includes';
import 'whatwg-fetch';
import { HttpService } from "./services/http-service";
import { ISettings } from '../typings/project';
import "../styles/app.scss";
import { Paths } from './paths';

export async function configure(aurelia: Aurelia): Promise<void> {

    if(navigator.userAgent.indexOf('MSIE')!==-1){
        //do not start if IE < 11
        return;
    }

    const http = new HttpService(new HttpClient());

    try {
      const settings = await http.get<ISettings>(Paths.getSettings);
      if (settings.isInternalUser) {
        try {
          const result = await http.get<string>(Paths.getIsAdmin, null, false);
          settings.isAdmin = result === "true";
        } catch (err) {
          settings.isAdmin = false;
        }
      } else {
        settings.isInternalUser = false;
      }
      start(settings);
    } catch (err) {
      //app is offline
      const dt: ISettings = <ISettings>{
        isAppOffline: true,
      };
      await start(dt);
    }

    async function start(data:ISettings):Promise<void>{
        aurelia.container.registerInstance("appSettings", data);
        aurelia.use.standardConfiguration()
       
        .feature(PLATFORM.moduleName('components/index'))
        .feature(PLATFORM.moduleName('value-converters/index'))
        .plugin(PLATFORM.moduleName('au-table'))
        
        //FIXME image resources below should be hosted as per https://www.npmjs.com/package/aurelia-google-maps#configuring-for-use
        .plugin(PLATFORM.moduleName('aurelia-google-maps'), (config: any) => {
            config.options({
                apiKey: data.googleMapsApiKey, 
                apiLibraries: 'drawing,geometry', 
                options: { panControl: true, panControlOptions: { position: 9 } },
                region: 'AU',
                markerCluster: {
                    enable: false,
                    src: 'https://cdn.rawgit.com/googlemaps/v3-utility-library/99a385c1/markerclusterer/src/markerclusterer.js', 
                    imagePath: 'https://cdn.rawgit.com/googlemaps/v3-utility-library/tree/master/markerclusterer/images/m', 
                    imageExtension: 'png',
                }
            });
        })
        .globalResources(PLATFORM.moduleName('toastr/build/toastr.css'));

        if (process.env.NODE_ENV !== 'production') {
            aurelia.use.developmentLogging();
        }
        
        try{
            await aurelia.start();
            await aurelia.setRoot(PLATFORM.moduleName('app'));
        } catch(error) {
            console.error(error);
        }
    }
}
